<div id="topbar" fxLayout="row" fxLayoutAlign="start center">
  <a routerLink="" title="Click here to go to Homepage">
    <img src="./assets/images/header-logo.png" fxShow fxHide.xs alt="UnitedHealthcare StudentResources Logo" />
    <img src="../assets/images/logoMobileUHC.svg" fxHide fxShow.xs alt="UnitedHealthcare StudentResources Logo" />
  </a>
  <div fxFlex></div>
  <!-- <a routerLink="/messages" class="message-icon" title="You have 22 new messages." *ngIf="isAuthenticated()">
    <mat-icon matBadge="22" matBadgePosition="above after"><img src="../assets/images/message.png"></mat-icon>
  </a> -->
  <mat-menu #appMenu="matMenu" class="uhc-menu" xPosition="after">
    <ul>
      <li>
        <a href="{{getFullUrl(menuUrls.usersUrl)}}" class="has-image" title="Click here to view Users">
          <!-- <img src="../../assets/images/setting.png" /> -->
          <img class="xdrop" src="../assets/images/user-icon.png">
          <span>Users</span>
        </a>
      </li>
      <li>
        <a href="javascript:void(0)" (click)="onSchoolSetupMenuClick()" class="has-image" title="Click here to view Setup Features" *ngIf="hasSchoolSetupAccess()">
          <img class="xdrop" src="../assets/images/setting.png">Setup Features
        </a>
      </li>
      <li>
        <a href="{{getFullUrl(menuUrls.myProfileUrl)}}" class="has-image" title="Click here to view My Profile">
          <!-- <img src="../../assets/images/setting.png" /> -->
          <img class="xdrop" src="../assets/images/user-icon.png">My Profile
        </a>
      </li>
      <li>
        <a href="{{getFullUrl(menuUrls.reportsUrl)}}" class="has-image" title="Click here to view Reports">
          <!-- <img src="../../assets/images/setting.png" /> -->
          <img class="xdrop" src="../assets/images/reports.png"> Reports
        </a>
      </li>
      <li role="separator" class="divider" fxHide fxShow.xs></li>
      <li>
        <a routerLink="#" (click)="onLogOut()" class="has-image" fxHide fxShow.xs title="Click here to Log Out">
          <img src="../../assets/images/logout.png" />
          Log Out
        </a>
      </li>
    </ul>
  </mat-menu>
  <a fxLayout="row" fxLayoutAlign="start center" class="user-block margin-right-10-px menu-header-text"
    [matMenuTriggerFor]="appMenu" *ngIf="isAuthenticated() && isInternalUser()" title="Click here to view Menu">
    <span class="user-icon">
      <img src="../assets/images/user-profile.png" title="User icon" />
    </span>
    <span class="user-name">
      {{currentUser.profile.FirstName}} {{currentUser.profile.LastName}}
    </span>
    <span class="caret"></span>
  </a>
  <a fxLayout="row" fxLayoutAlign="start center" class="user-block margin-right-10-px menu-header-text"
    *ngIf="isAuthenticated() && !isInternalUser()" href="{{getFullUrl(menuUrls.myProfileUrl)}}" title="View Profile">
    <span class="user-icon">
      <img src="../assets/images/user-profile.png" title="User icon" />
    </span>
    <span class="user-name">
      {{currentUser.profile.FirstName}} {{currentUser.profile.LastName}}
    </span>
  </a>
  <a fxLayout="row" class="menu-header-text" fxHide.xs fxLayoutAlign="start center" href="javascript:void(0)"
    (click)="onLogOut()" *ngIf="isAuthenticated()" title="Log Out">
    <span class="margin-right5">
      <img src="../assets/images/logout.png" alt="Logout icon" />
    </span>
    <span>LogOut</span>
  </a>
  <a fxLayout="row" routerLink="/" fxHide.xs fxLayoutAlign="start center" href="javascript:void(0)"
    *ngIf="!isAuthenticated()" title="Login to Partner Center">
    <!-- <span class="margin-right5">
      <img src="../assets/images/login.png" alt="Logout icon" />
    </span> -->
    Login to Partner Center
  </a>
  <a fxHide fxShow.xs fxShow.sm fxShow.lt-md (click)="toggleSideNav()" *ngIf="isAuthenticated()">
    <img src="../../assets/images/setup_features.png" height="45" alt="menu button" />
  </a>
</div>


<div class="navbar" id="navbar">
  <div class="navbar-color">
    <div class="container">
      <div class="subnav" *ngFor="let module of modules" routerLinkActive="active"
        [attr.id]="'navDiv' + module.blockName ">
        <a routerLinkActive="active" class="subnavHomeColor" routerLink="/dashboard" *ngIf="module.blockName === 'Home'"
          title="{{homeModule.description}}" (click)="onClickNavgation(module, false)"
          [attr.id]="'nav' + module.blockName">{{homeModule.blockName |
          titlecase}}</a>
        <a href="javascript:void(0)" class="subnavbtn" *ngIf="canAccess(module) && module.transform"
          title="{{module.description}}" [className]="module.isDisabled?'disabled':''"
          (click)="onClickNavgation(module);" id="navigation" [attr.id]="'nav' + module.blockName">{{module.blockName |
          titlecase}}
        </a>
        <a class="subnavbtn" *ngIf="canAccess(module) && !module.transform" title="{{module.description}}"
          href="javascript:void(0)" [className]="module.isDisabled?'disabled':''" [attr.id]="'nav' + module.blockName"
          (click)="onClickNavgation(module)">
          <span>{{module.blockName | titlecase}}</span></a>

      </div>
    </div>
  </div>
  <div class="sub-navbar-color">
    <div class="container">
      <div *ngFor="let module of modules" class="subnav-content" [attr.id]="'subnav' + module.blockName "
        [attr.access]="canAccess(module)">
        <div class="subnav" routerLinkActive="active" *ngFor="let block of module.blocks">
          <a class="subnavbtn" href="javascript:void(0)" [attr.id]="'link'+block.blockName"
            [attr.class]="'link'+module.blockName" *ngIf="HasAcesstoSubModule(block.blockName)"
            (click)="OnNavigationSubNav(module,block.blockName,block.url);">
            <span>{{block.blockName}}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>


<div id="page-title-bar" *ngIf="isAuthenticated() || showPageTitleBar">
  <div class="container">
    <div fxLayout="row" fxLayoutGap="30px">
      <div fxFlex="32" fxLayoutAlign="space-between center">
        <h1 class="uhc-h1" *ngIf="!showPageTitleBar || handleList">{{defaultpageTitleBarText}}</h1>
        <h1 class="uhc-h1" *ngIf="showPageTitleBar && !handleList">{{pageTitleBarText}}</h1>
      </div>
      <div fxFlex="66" fxLayout="row" fxLayoutAlign="space-between center">
      <!-- Hide in Insurance AND School Setup -->
      <app-select-policy-year *ngIf="!isInsuranceModule() && !isSchoolSetupModule()" fxFlex="0 0 35%">
      </app-select-policy-year>
      
      <!-- Spacer only for school setup -->
        <div fxFlex="35" *ngIf="isSchoolSetupModule()"></div>

      <!-- Show in all except Insurance -->
      <app-search-school *ngIf="!isInsuranceModule()"  fxFlex="0 0 65%">
      </app-search-school>
    </div>
    </div>
  </div>
</div>
<div class="loading-bodyspinner" [ngClass]="{'allow-margin': applyMargin}" *ngIf="loading && policyLoader">
  <div class="loading-bodyspinner inner-div">
    <div class="loading-bar-bodyspinner" [ngClass]="{'allow-margin': applyMargin}">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  </div>
</div>
<div class="main-content" *ngIf="handleList">
  <div class="container">
    <ng-container>
      <app-select-school [clients]="clients" (selectClient)="selectClient($event)" [showCloseButton]="true"
        (closeClientSelect)="closeClientSelect($event)">
      </app-select-school>
    </ng-container>
  </div>
</div>
